jQuery(function ($) {
  var $checkbox = $('.checkbox input[type="checkbox"]');

  $checkbox.on('click', function () {
    $(this).parent().toggleClass('active', this.checked);
  });

  $('.checkbox input:checked').parent().addClass('active');
});
